import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Ref } from "@eastsideco/salvo-ts";

@Component
export class PasswordModal extends ThemeComponent {
    @Ref modalTrigger!: HTMLElement;
    @Ref modalClose!: HTMLElement;
    @Ref modalContent!: HTMLElement;

    init() {
        this.$listen(this.modalTrigger, 'click', this.handleModalTrigger.bind(this));
        this.$listen(this.modalClose, 'click', this.handleModalClose.bind(this));
    }

    handleModalTrigger() {
        this.classList.add('is-visible');
    }

    handleModalClose() {
        this.classList.remove('is-visible');
    }
}
